import { render, staticRenderFns } from "./CIGWarehouseImage.vue?vue&type=template&id=e1f53f68&"
import script from "./CIGWarehouseImage.vue?vue&type=script&lang=js&"
export * from "./CIGWarehouseImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports